import apiClient from "./ApiService";
import { PATH_DOCUMENTS } from "../config/env";

export const getDocuments = async()=>{
    return await apiClient.get(PATH_DOCUMENTS);
}
export default getDocuments;